'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiHomeOutline = function TiHomeOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.1 17.4c-5.6-4.7-15.9-13.6-16-13.7l-1.1-0.9-1.1 0.9c-0.1 0.1-10.4 9-16.1 13.8-0.7 0.6-1.1 1.6-1.1 2.5 0 1.8 1.5 3.3 3.3 3.3h1.7v10c0 1.9 1.5 3.4 3.3 3.4h20c1.8 0 3.3-1.5 3.3-3.4v-10h1.7c1.8 0 3.3-1.5 3.3-3.3 0-1-0.4-1.9-1.2-2.5z m-13.8 15.9h-6.6v-8.3h6.6v8.3z m6.7-13.3l0 13.3h-5v-10h-10v10h-5v-13.3h-5c4.6-3.9 12.2-10.4 15-12.8 2.8 2.4 10.4 8.9 15 12.8 0 0-5 0-5 0z' })
        )
    );
};

exports.default = TiHomeOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/home-outline.js
// module id = 3620
// module chunks = 0